export const UrlSearchFilterProperty = {
    // Common

    PAYMENT_STATUS: 'payment_status',
    CUSTOMER_NAME: 'customer_name',
    CUSTOMER_ID: 'customer_id',
    DATE_FROM: 'date_from',
    DATE_TO: 'date_to',

    SUPPLIER_NAME: 'supplier_name',
    SUPPLIER_ID: 'supplier_id',

    USER_NAME: 'user_name',
    USER_ID: 'user_id',

    BRAND_NAME: 'brand_name',
    BRAND_ID: 'brand_id',

    // Purchase
} as const;
